import { ref } from 'vue'
import { normalizeBaseCatalog } from '@/common/normalize/normalize-base-catalog'
import { apiRequest } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import { getContextProperty } from '@/common/converter/utils/get-context-property'
import { convertCellEventList } from '@/common/converter/convert-event-list'

export const useCatalog = () => {
  const contextList = ref([])

  /**
   * 카탈로그 데이터를 가져온다.
   * @param url
   * @returns {Promise<AxiosResponse>}
   */
  const getCatalog = async (url = '') => {
    const response = await apiRequest({
      url: `https://${url}`,
      method: HTTP_METHOD_GET,
    })

    const data = normalizeBaseCatalog(response?.data?.data)
    contextList.value = data?.contextList

    return response
  }

  /**
   * context 에 contextProperty 와 index 를 추가한다.
   * @param elementList
   */
  const addContextProperty = (elementList = {}) => {
    const contextProperty = getContextProperty(elementList)

    contextList.value = contextList.value.map((context, index) => ({
      ...context,
      index: `${index}`,
      contextProperty,
    }))
  }

  /**
   * context 에 eventList 를 추가한다.
   * @param elementList
   */
  const addEventList = (elementList = {}) => {
    const eventList = convertCellEventList(elementList)

    contextList.value = contextList.value.map((context) => ({
      ...context,
      eventList,
    }))
  }

  /**
   * context 에 contextProperty 와 index, eventList 를 추가한다.
   * @param elementList
   */
  const addContextPropertyAndEventList = (elementList = []) => {
    const contextProperty = getContextProperty(elementList)
    const eventList = convertCellEventList(elementList)

    contextList.value = contextList.value.map((context, index) => {
      return {
        ...context,
        index: `${index}`,
        contextProperty,
        eventList,
      }
    })
  }

  return {
    contextList,
    getCatalog,
    addContextProperty,
    addEventList,
    addContextPropertyAndEventList,
  }
}
